export default "__VITE_ASSET__DzsqbdgV__"